export default "__VITE_ASSET__DFEDvWK___"